import type { StyleSheet } from 'react-native';
import type { allStyleTypes, ThemeTreeType } from 'types/index.d';
import { ThemeError } from './errors';
import { isThemeTreeType } from './utilities/validation';

const coreThemeTypes: string[] = [
  'background', 'text', 'textItalic', 'textBold'
];


export function buildTheme(obj: ThemeTreeType): StyleSheet.NamedStyles<any> {

  var styles: { [key: string]: allStyleTypes } = {};
  var errors: string[] = [];
  processBranch(obj, styles, errors, {});

  var missing: string[] = [...coreThemeTypes];
  Object.keys(styles).forEach((key) => {
    const pos = missing.indexOf(key);
    if (pos > -1) missing.splice(pos, 1);
    //TODO: Validate types.
  })
  if (missing.length > 0 || errors.length > 0) {
    throw new ThemeError({ action: 'Failed to create Theme from tree', missing: missing, errors: errors });
  }
  return styles;
}

function processBranch(obj: ThemeTreeType, styles: { [key: string]: allStyleTypes }, errors: string[], current: allStyleTypes): void {

  Object.keys(obj).forEach(key => {
    if (key === 'style') return;
    if (styles[key] !== undefined) errors.push(`${key} is defined more than once\n`);
    if (isThemeTreeType(obj[key])) {
      processBranch(obj[key], styles, errors, Object.assign({}, current, obj[key].style));
    }
    else {
      errors.push(`${key} lacks some style or has invalid styles`);
    }
  });
}


